export enum TaxonomyItem {
	Taxonomy,
	TermGroup,
	TermSet,
	Term,
}
